import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const StyleUploadInput = styled.input`
  display: none;
`;

export const StyleDragImageWrapper = styled.img<any>`
  width: 100%;
  height: ${(props) => props.size}px;
  object-fit: contain;
  min-height: 350px;
  border-radius: 12px;
  transition: all 200ms linear;

  &:hover {
    scale: 1.02;
  }

  @media (max-width: 768px) {
    object-fit: contain;
  }

  ${(props: any) =>
    props.isOgImage &&
    css`
      min-height: 223px;
      height: 150px;
    `}
`;

export const StyleBannerUploadWrapper = styled.div<any>`
  width: 100%;
  height: ${(props: any) => props.height || 330}px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  background-color: ${({ hasImage, theme }: any) =>
    hasImage ? "transparent" : theme.orange.orange50};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ hasImage, theme }: any) =>
      hasImage ? "transparent" : theme.orange.orange100};
  }

  ${(props: any) =>
    props.isOgImage &&
    css`
      min-height: 0;
      width: 87%;
    `}
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  .spin {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const StyleBannerUploadPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #64748b;

  span {
    font-size: 14px;
  }
`;

export const StyleThumbnailWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;

export const StyleThumbnail = styled.div<any>`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
  width: ${(props: any) => props.size || 240}px;
  aspect-ratio: 1 / 1;
  border-radius: 8px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  button {
    position: absolute;
    top: 0px;
    right: 0px;
    background: red;
    border: none;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const StyleUploadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #333;
  font-weight: bold;
  z-index: 2;
`;

export const StyleProfileUploadWrapper = styled.div<any>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 12%;
  background-color: ${(props: any) => props.theme.orange.orange500};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props: any) => props.theme.orange.orange400};
  }
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  .spin {
    animation: spin 1s linear infinite;
  }
`;

// Circular profile image
export const StyleProfileImageWrapper = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

// Placeholder for profile upload
export const StyleProfilePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  gap: 4px;
  span {
    font-size: 14px;
  }
`;

// Add these to your existing styled components

export const StyleVideoWrapper = styled.div<{
  isOgImage?: boolean;
  fit?: string;
  size?: number;
}>`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyleThumbnailVideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  .video-indicator {
    position: absolute;
    top: 4px;
    right: 4px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }
`;
